import { useEffect, useState } from "react";
import styles from "./templates.module.css";
import Helmet from "react-helmet";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton, Slide, Snackbar, Typography } from "@mui/material";
import { Home, X } from "react-feather";
import Loader from "../../../components/Loader";
import { useAuth0 } from "@auth0/auth0-react";
import Footer from "../../../components/Footer";
import TemplateCard from "./components/TemplateCard";
import TemplateFilter from "./components/TemplateFilter";
import axios from "axios";
import { TableLoader } from "../../../components/LoaderC";
import { toast } from 'react-smart-toaster';
import { AddLogCallAPI } from "../../../components/AddLogs";
import withCustomAuthenticationRequired from "../../../auth/withCustomAuthenticationRequired";

const OfferTemplates = () => {
    const { getAccessTokenSilently } = useAuth0();
    const [loading, setLoading] = useState(false);
    const [contentLoading, setContentLoading] = useState(true);
    const [allData, setAllData] = useState([]);
    const [fileredData, setFileredData] = useState([]);
    const [archiveModalOpen, setArchiveModalOpen] = useState(false);
    const [publishModalOpen, setPublishModalOpen] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMsg, setSnackbarMsg] = useState("");
    const [deleteModalOpen, setDeleteModalOpen] = useState(false);

    useEffect(() => {
        const fetchTemplates = async () => {
            const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
            axios(process.env.REACT_APP_PAYMENT_API_URL + "v1/lease-renewal/template", {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            }).then((response) => {
                setContentLoading(false);

                setAllData(response.data.data);
            }).catch((error) => {
                setContentLoading(false);
            });
        }
        fetchTemplates();
    }, [getAccessTokenSilently]);

    useEffect(() => {
        let fileredDataTemp = allData;

        setFileredData(fileredDataTemp);
    }, [allData]);

    const changeStatusConfirm = async (data) => {
        setLoading(true);
        setArchiveModalOpen(false);
        setPublishModalOpen(false);
        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

        axios.put(process.env.REACT_APP_PAYMENT_API_URL + 'v1/lease-renewal/template/' + selectedItem?.id, { is_archived: data }, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }).then((response) => {
            setLoading(false);

            setSnackbarMsg("Email campaign updated successfully.");
            setSnackbarOpen(true);

            setAllData(prev => {
                return prev?.map((item) => {
                    if (item.id === selectedItem?.id) {
                        return { ...item, is_archived: data };
                    }
                    return item;
                })
            });

            let logData = {
                title: "Offer template status has been updated successfully.",
                description: [
                    "Name: " + selectedItem?.title
                ],
            };
            AddLogCallAPI(logData, token);

            setSelectedItem(null);
        }).catch((error) => {
            if (typeof error.response !== "undefined")
                toast.error(error.response.data.message);
            setLoading(false);
        });
    }

    const confirmDelete = async () => {
        setDeleteModalOpen(false);
        setLoading(true);
        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

        axios.delete(process.env.REACT_APP_PAYMENT_API_URL + 'v1/lease-renewal/template/' + selectedItem?.id, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }).then(response => {
            setSnackbarOpen(true);
            setSnackbarMsg(response.data.message);
            setLoading(false);

            setAllData(prev => {
                return prev?.filter(i => i?.id !== selectedItem?.id);
            });

            let logData = {
                title: "A template has been deleted successfully.",
                description: [
                    "Name: " + selectedItem?.title
                ],
            };
            AddLogCallAPI(logData, token);

            setSelectedItem(null);
        }).catch(error => {
            if (typeof error.response !== 'undefined')
                toast.error(error.response.data.message);
            setLoading(false);
        });
    }

    const copyOfferTemplate = async (id) => {
        setLoading(true);

        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

        axios.post(process.env.REACT_APP_PAYMENT_API_URL + "v1/lease-renewal/template/copy/" + id, {}, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }).then((response) => {
            setLoading(false);

            setSnackbarMsg(response?.data?.message);
            setSnackbarOpen(true);

            setAllData(prev => {
                return [response?.data?.data].concat(prev);
            });

            let logData = {
                title: "A template has been updated copied successfully.",
                description: [
                    "Name: " + response?.data?.data?.title
                ],
            };
            AddLogCallAPI(logData, token);

        }).catch((error) => {
            if (typeof error.response !== "undefined")
                toast.error(error.response.data.message);
            setLoading(false);
        });
    }

    return (<>
        {loading && <Loader />}
        <Helmet title="Renewal Offer Template" />

        <div className={`${styles.pageTitleWrap}`}>
            <Typography display="inline" className={`${styles.pageTitle}`}>Renewal Offer Template</Typography>
            <nav aria-label="breadcrumb">
                <ol className={`${styles.breadcrumb}`}>
                    <li className={`${styles.breadcrumbItem}`}><span><Home /></span>Lease Renewal</li>
                    <li className={`${styles.breadcrumbItem} ${styles.active}`}>Offer Template</li>
                </ol>
            </nav>
        </div>

        <div className={`${styles.BodyCon}`}>
            <div className={`${styles.mainCardDiv}`}>
                <div className={`${styles.mainCard}`}>
                    <div className="control-pane">
                        <div className={`${styles.Row}`}>

                            {contentLoading && (<div className="Loader TableLoader">
                                <TableLoader />
                            </div>)}

                            {!contentLoading && <>

                                <TemplateFilter />

                                <div className={`${styles.LogMaiSec}`}>

                                    {/* <div className={`${styles.IncomeListUnderSec}`}>
                                        <TableContainer className={`${styles.TableDiv} CustomTableDiv`}>
                                            <Table>
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell className={`${styles.TableHead}`} style={{ width: 400 }}>Name</TableCell>
                                                        <TableCell className={`${styles.TableHead}`} style={{ width: 150 }}>Status</TableCell>
                                                        <TableCell className={`${styles.TableHead}`} style={{ width: 150 }}>Lease Expiration</TableCell>
                                                        <TableCell className={`${styles.TableHead}`} style={{ width: 100 }}></TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>

                                                    {fileredData?.map((item) => {
                                                        return <TemplateCard item={item} setSelectedItem={setSelectedItem.bind(this)} setArchiveModalOpen={setArchiveModalOpen.bind(this)} setPublishModalOpen={setPublishModalOpen.bind(this)} setDeleteModalOpen={setDeleteModalOpen.bind(this)} copyOfferTemplate={copyOfferTemplate.bind(this)} />
                                                    })}

                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </div> */}

                                    {fileredData?.map((item) => {
                                        return <TemplateCard item={item} setSelectedItem={setSelectedItem.bind(this)} setArchiveModalOpen={setArchiveModalOpen.bind(this)} setPublishModalOpen={setPublishModalOpen.bind(this)} setDeleteModalOpen={setDeleteModalOpen.bind(this)} copyOfferTemplate={copyOfferTemplate.bind(this)} />
                                    })}

                                </div>
                            </>}

                        </div>
                    </div>
                </div>
            </div>
        </div>

        <Dialog
            open={archiveModalOpen}
            onClose={(e) => setArchiveModalOpen(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="NewPopUp"
            fullWidth
            maxWidth="sm"
        >
            <DialogTitle id="alert-dialog-title">Are you sure you want to archive offer template?<button onClick={(e) => setArchiveModalOpen(false)}><X /></button></DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    <div className="ModalFormGroup">
                        <label className="PopupBodyText">The offer template will be archived immediately. You can publish it at any time.</label>
                    </div>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <button onClick={(e) => setArchiveModalOpen(false)} className="CancelPopupBU">Cancel</button>
                <button className="SubmitPopupBU" onClick={(e) => changeStatusConfirm(1)}>Archive</button>
            </DialogActions>
        </Dialog>

        <Dialog
            open={publishModalOpen}
            onClose={(e) => setPublishModalOpen(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="NewPopUp"
            fullWidth
            maxWidth="sm"
        >
            <DialogTitle id="alert-dialog-title">Are you sure you want to publish offer template?<button onClick={(e) => setPublishModalOpen(false)}><X /></button></DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    <div className="ModalFormGroup">
                        <label className="PopupBodyText">The offer template will be published immediately. You can unpublish it at any time.</label>
                    </div>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <button onClick={(e) => setPublishModalOpen(false)} className="CancelPopupBU">Cancel</button>
                <button className="SubmitPopupBU" onClick={(e) => changeStatusConfirm(0)}>Publish</button>
            </DialogActions>
        </Dialog>

        <Dialog
            open={deleteModalOpen}
            onClose={(e) => setDeleteModalOpen(false)}
            fullWidth
            maxWidth="sm"
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="NewPopUp"
        >
            <DialogTitle id="alert-dialog-title">
                Would you like to delete this offer template?
                <button onClick={(e) => setDeleteModalOpen(false)}><X /></button>
            </DialogTitle>
            <DialogContent>
                <div className="ModalFormGroup">
                    <label className="PopupBodyText">The offer template information will be removed immediately. You can't undo this action.</label>
                </div>
            </DialogContent>
            <DialogActions>
                <Button onClick={(e) => confirmDelete(false)} className="CancelPopupBU">Delete</Button>
                <Button onClick={(e) => setDeleteModalOpen(false)} className="SubmitPopupBU">Cancel</Button>
            </DialogActions>
        </Dialog>


        <Snackbar
            open={snackbarOpen}
            onClose={(e) => setSnackbarOpen(false)}
            TransitionComponent={Slide}
            message={snackbarMsg}
            autoHideDuration={10000}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            action={
                <IconButton
                    size="small"
                    aria-label="close"
                    color="inherit"
                    onClick={(e) => setSnackbarOpen(false)}
                >
                    <X />
                </IconButton>
            }
        />

        <Footer />
    </>
    )
}

export default withCustomAuthenticationRequired(OfferTemplates, {
    onRedirecting: () => <Loader />,
});